import { useEffect, type FC, type PropsWithChildren } from 'react';

import { PAY_METHOD } from 'constants/payment';
import { useTranslate } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setAcquiring } from 'store/payment/slice';

import { Footer } from '../../components/1xbet/ui/footer';
import { Header } from '../../components/1xbet/ui/header';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const dispatch = useAppDispatch();
  const { t } = useTranslate();

  useEffect(() => {
    const bankAcquiring = paymentData?.acquirings.find((item) => {
      switch (item.formType) {
        case PAY_METHOD.BANK_CARD_1:
        case PAY_METHOD.BANK_CARD_3:
        case PAY_METHOD.BANK_CARD_9:
          return true;
        default:
          return false;
      }
    });

    if (bankAcquiring) {
      dispatch(setAcquiring(bankAcquiring));
    }
  }, [paymentData, dispatch]);

  return (
    <div className="flex min-h-dvh font-inter flex-col items-center md:gap-6 bg-white text-1xbet-gray-100 md:min-h-screen justify-between px-4 py-4 md:px-8 md:py-6">
      <Header>{t('1xbet.add-balance')}</Header>
      {children}
      <Footer />
    </div>
  );
};

export { Layout };
